import React from "react";
import { Navigate } from "react-router-dom";

import { DemoProvider } from "@/features/demo/components/DemoProvider";
import MenuPageV3 from "@/features/restaurant/pages/MenuPage.V3";
import { ProtectedRouteV2 } from "@/components/ProtectedRouteV2";
import { useSmartRouteResolution } from "./smart-routes/useSmartRouteResolution";

const LEGACY_REDIRECTS: Record<string, string> = {
  "/payments": "payments",
  "/qr-codes": "qr-codes",
  "/settings/staff": "settings/staff",
};

const smartRouteDebugEnabled = import.meta.env.DEV && import.meta.env.VITE_DASHBOARD_DEBUG === "1";

export const SmartMenuRoute: React.FC = () => {
  const resolution = useSmartRouteResolution({
    routeKey: "menu",
    legacyRedirects: LEGACY_REDIRECTS,
  });

  if (smartRouteDebugEnabled) {
    console.debug("[SmartMenuRoute] context:", resolution.context);
  }

  if (resolution.redirectPath) {
    return <Navigate to={resolution.redirectPath} replace />;
  }

  if (resolution.shouldRenderDemo) {
    return (
      <DemoProvider>
        <MenuPageV3 />
      </DemoProvider>
    );
  }

  return (
    <ProtectedRouteV2 legacyPage="menu">
      <MenuPageV3 />
    </ProtectedRouteV2>
  );
};
